import { getCameras, getMicrophones } from '@huntica/huntica-interview-module/src/mediaHelpers';
import { localeType } from '@/enums';

export function safeGet(o, props, defaultValue = null) {
  return props.reduce((acc, current) => ((acc && acc[current]) ? acc[current] : defaultValue), o);
}

export function normalizePhoneNumber(value) {
  return String(value).replace(/[ -]/g, '');
}

export function pick(object, keys) {
  return keys.reduce((acc, key) => {
    if (key in object) {
      acc[key] = object[key];
    }

    return acc;
  }, {});
}

export function readableSeconds(seconds) {
  const date = new Date(null);
  date.setSeconds(seconds);

  if (Math.floor(seconds / 3600) > 0) {
    return date.toISOString().substr(11, 8);
  }

  return date.toISOString().substr(14, 5);
}

export function cabinetUrl(url) {
  if (!url || typeof url !== 'string') {
    return process.env.VUE_APP_CABINET_URL;
  }

  return `${process.env.VUE_APP_CABINET_URL}${url}`;
}

export function isIOS() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && !window.ManagedMediaSource;
}

export async function getDeviceInfo() {
  const microphones = await getMicrophones();
  const selectedMicrophone = localStorage.getItem('microphoneId');
  const cameras = await getCameras();
  const selectedCamera = localStorage.getItem('cameraId');

  const microphonesString = microphones.map(microphone => Object
    .entries(microphone.toJSON())
    .map(e => e.join(': '))
    .join('\n'))
    .join('\n\n');

  const camerasString = cameras.map(camera => Object
    .entries(camera.toJSON())
    .map(e => e.join(': '))
    .join('\n'))
    .join('\n\n');

  return [
    `Выбранный микрофон: ${selectedMicrophone}`,
    `Все микрофоны:\n${microphonesString}`,
    `Выбранная камера:${selectedCamera}`,
    `Все камеры:\n${camerasString}`,
  ].join('\n\n');
}

export function detectBrowserLocale() {
  const browserLocale = window.navigator.language || window.navigator.userLanguage;

  if (!browserLocale) {
    return localeType.DEFAULT;
  }

  const locale = browserLocale.split('-').shift();

  if (!locale || !Object.keys(localeType).includes(locale.toUpperCase())) {
    return localeType.DEFAULT;
  }

  return localeType[locale.toUpperCase()];
}
